import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgRichMoisturizerGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M29 8H19v1.695l1.856 24.922v3.688l.103.1c.515 1.097 1.959 1.495 3.093 1.495h.206c1.443-.1 2.474-.697 2.783-1.595l.103-4.187L29 9.994V8Zm-4.845 30.804c-.928 0-1.753-.2-2.062-.698v-2.093c.618.299 1.237.398 1.855.398h.207c.618 0 1.134-.2 1.546-.398v2.093c-.103.399-.722.598-1.546.698Zm1.65-4.586v.2c-.207.398-.826.598-1.65.697-.928 0-1.753-.2-2.062-.698L20.237 9.994v-.798h7.423v.499l-1.856 24.523Z",
    fill: "currentColor"
  }));
}

export { SvgRichMoisturizerGlyph as default };
